import { forwardRef } from "react";
import { IMaskInput, IMaskInputProps } from "react-imask";
import {
  IInputContainerProps,
  InputContainer,
} from "../InputContainer/inputContainer";

type InputMaskProps = IInputContainerProps & IMaskInputProps<HTMLInputElement>;

export const InputMask = forwardRef<HTMLInputElement, InputMaskProps>(
  ({ label, ...rest }, ref) => {
    return (
      <InputContainer label={label} required={rest.required}>
        <IMaskInput inputRef={ref} {...rest} />
      </InputContainer>
    );
  }
);
